// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9r1wr","name":"styles_name__2sPl9","phone":"styles_phone__1N9g2"};